var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1216 0.549316C4.60758 0.549316 0.121582 5.03532 0.121582 10.5493C0.121582 16.0633 4.60758 20.5493 10.1216 20.5493C15.6356 20.5493 20.1216 16.0633 20.1216 10.5493C20.1216 5.03532 15.6356 0.549316 10.1216 0.549316ZM8.12258 14.9623L5.11703 11.9632C4.72628 11.5733 4.72549 10.9405 5.11527 10.5496C5.50529 10.1585 6.13859 10.1578 6.52951 10.548L8.12058 12.1363L12.7076 7.54932C13.098 7.15885 13.7311 7.15885 14.1216 7.54932C14.512 7.93978 14.512 8.57285 14.1216 8.96332L8.12258 14.9623Z",
    fill: "#2FAB73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.e4897878a176cae2d42e6e6125b10d4b.svg";
export { ForwardRef as ReactComponent };